let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("6qah4"), load("3XMOA"), load("ffEVr"), load("aIuOE")]).then(() => parcelRequire('56n4X'));